module.exports = __webpack_public_path__ + "04f5779f365db35baaa4b8bff89c1966.jpg";